import * as React from 'react';
import { Switch } from 'antd';
import {
  localizedString
} from '@locale/index';
import { isEqual } from '@lib/index';

import '@style/component/qualification/index.less';

interface QualificationProps {
  disabled?: boolean;
  placeholder?: string;
  external: boolean;
  onChange: (external: boolean) => void;
}

interface QualificationState {
  external: boolean;
  diffVisible: boolean;
}

export class Qualification extends React.Component<QualificationProps, QualificationState> {
  state = {
    external: false,
    diffVisible: false
  };
  componentDidMount() {
    this.onInit();
  }

  componentDidUpdate(prevProps: any) {
    if (!isEqual(prevProps, this.props)) {
      this.onInit();
    }
  }

  onInit = () => {
    this.setState({ external: this.props.external });
  }

  render() {
    const state = this.state;
    const props = this.props;

    return <div className="external-group">
      {localizedString('common_external')}
      < Switch
        key="external"
        disabled={props.disabled}
        style={{ marginLeft: 16 }}
        checked={state.external}
        onChange={(checked: boolean, event: MouseEvent) => {
          this.setState({ external: checked });
          this.props.onChange(checked);
        }}
      />
    </div>;
  }
}
